module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/pagination/pagination.component.sass
// module id = ./src/app/common/pagination/pagination.component.sass
// module chunks = main